import Router from 'vue-router';

export default function (Vue) {
	Vue.use(Router);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				name: 'page-home',
				component: () => import('@/pages/page-home'),
			},
			{
				path: '/pagoexitoso',
				name: 'page-pago-exitoso',
				component: () => import('@/pages/page-pago-exitoso'),
			},
			{
				path: '/pagoproceso',
				name: 'page-pago-proceso',
				component: () => import('@/pages/page-pago-proceso'),
			},
			{
				path: '/activa-tu-app/:token?',
				name: 'generate-app',
				component: () => import('@/pages/page-generate-app'),
				props: true,
			},
			{
				path: '/pfb',
				name: 'page-pago-proceso-pfb',
				component: () => import('@/pages/page-home'),
				meta: {
					origin: 'pfb',
				},
			},
			{
				path: '/wsf',
				name: 'page-pago-proceso-wsf',
				component: () => import('@/pages/page-home'),
				meta: {
					origin: 'wsf',
				},
			},
			{
				path: '/mfb',
				name: 'page-pago-proceso-mfb',
				component: () => import('@/pages/page-home'),
				meta: {
					origin: 'mfb',
				},
			},
			{
				path: '/ig',
				name: 'page-pago-proceso-ig',
				component: () => import('@/pages/page-home'),
				meta: {
					origin: 'ig',
				},
			},
			{
				path: '/:fullName/activacion-exitosa',
				name: 'page-success-inscription',
				component: () => import('@/pages/page-success-inscription'),
				props: true,
			},
		],
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition;
			}
			return { x: 0, y: 0 };
		},
	});
	config.beforeEach((to, from, next) => next());
	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js